(() => {
  'use strict';

  const widgetSelector = '.ol-pdp .subscriptions_app_embed_block';
  const optionSelector = '.shopify_subscriptions_app_block_label.shopify_subscriptions_purchase_option_wrapper, .shopify_subscriptions_purchase_option_wrapper';
  const choiceIcons = Object.freeze({
    'one-time': '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" focusable="false"><rect x="6.75" y="10.5" width="34.5" height="30" rx="4.5" fill="none" stroke="#27577A" stroke-width="2.4"/><path d="M7.2 19h33.6M16 7v8M32 7v8" fill="none" stroke="#27577A" stroke-linecap="round" stroke-width="2.4"/><g transform="translate(24 30) scale(.78) translate(-24 -30)"><path d="m15.5 29 5.3 5.2 11.8-12.4" fill="none" stroke="#35B6A9" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></g></svg>',
    subscription: '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" focusable="false"><rect x="6.75" y="10.5" width="34.5" height="30" rx="4.5" fill="none" stroke="#27577A" stroke-width="2.4"/><path d="M7.2 19h33.6M16 7v8M32 7v8" fill="none" stroke="#27577A" stroke-linecap="round" stroke-width="2.4"/><g transform="translate(24 30) scale(.78) translate(-24 -30)"><path d="M16.5 30a9 9 0 0 1 14-6.5" fill="none" stroke="#35B6A9" stroke-linecap="round" stroke-width="3.1"/><path d="m28 21.5 4.3 1.7-1.7 4.3z" fill="#35B6A9"/><path d="M31.5 29a9 9 0 0 1-14 6.5" fill="none" stroke="#27577A" stroke-linecap="round" stroke-width="3.1"/><path d="m20 37.5-4.3-1.7 1.7-4.3z" fill="#27577A"/></g></svg>'
  });

  function normaliseText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function findOption(widget, matcher) {
    const candidates = Array.from(widget.querySelectorAll(optionSelector));
    const matchingOption = candidates.find((candidate) => matcher.test(normaliseText(candidate.textContent)));
    const matchedLabel = matchingOption || Array.from(widget.querySelectorAll('label'))
      .find((label) => matcher.test(normaliseText(label.textContent)));

    if (!matchedLabel) return null;

    // Shopify nests delivery cadence under the subscription purchase option.
    // Mark its outer group so the blank space across both lines also selects it.
    const optionGroup = matchedLabel.closest('.shopify_subscriptions_app_block_label');
    if (!optionGroup || optionGroup === matchedLabel) return matchedLabel;

    const separatePurchaseChoice = Array.from(optionGroup.querySelectorAll('.shopify_subscriptions_purchase_option_wrapper'))
      .some((candidate) => candidate !== matchedLabel
        && !matchedLabel.contains(candidate)
        && /one[ -]?time purchase|subscribe and save/.test(normaliseText(candidate.textContent)));

    return separatePurchaseChoice ? matchedLabel : optionGroup;
  }

  function makeOptionAreaClickable(option) {
    if (option.dataset.olSubscriptionClickArea === 'true') return;

    option.dataset.olSubscriptionClickArea = 'true';
    option.addEventListener('click', (event) => {
      const target = event.target;
      if (!target || typeof target.closest !== 'function'
        || target.closest('a, button, input, label, select, textarea')) return;

      const primaryLabel = option.matches('label.shopify_subscriptions_purchase_option_wrapper')
        ? option
        : option.querySelector(':scope > .shopify_subscriptions_purchase_option_wrapper');
      const primaryRadio = primaryLabel && primaryLabel.querySelector('input[type="radio"]');

      // Leave native labels and delivery-frequency radios to Shopify.
      if (primaryRadio && !primaryRadio.checked) primaryRadio.click();
    });
  }

  function addChoiceIcon(option, kind) {
    if (option.querySelector(':scope > .ol-subscription-choice-icon')) return;

    const icon = document.createElement('span');
    icon.className = 'ol-subscription-choice-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = choiceIcons[kind];
    option.append(icon);
  }

  function enhanceOption(option, kind) {
    if (!option) return null;

    option.classList.add('ol-subscription-choice');
    option.dataset.olSubscriptionChoice = kind;
    addChoiceIcon(option, kind);
    makeOptionAreaClickable(option);
    return option;
  }

  function enhanceWidget(widget) {
    enhanceOption(findOption(widget, /one[ -]?time purchase/), 'one-time');
    enhanceOption(findOption(widget, /subscribe and save/), 'subscription');
  }

  let scanQueued = false;
  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    window.requestAnimationFrame(() => {
      scanQueued = false;
      document.querySelectorAll(widgetSelector).forEach(enhanceWidget);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueScan, { once: true });
  } else {
    queueScan();
  }

  if (document.documentElement) {
    new MutationObserver(queueScan).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
